<template>
    <div class="page" style="padding:12px">
        <div class="top">
            <el-button size="medium" type="primary" @click="jumpToPage('schoolCalendarAdd')">新增</el-button>
        </div>
        <div>
            <el-table
                :data="dataList"
                :height="windowHeight - 200"
                style="width: 100%" border
            >
                <el-table-column
                    label="学年"
                    show-overflow-tooltip
                    align="center"
                    :resizable="false"
                >
                    <template slot-scope="scope">
                        <router-link class="link-type" :to="{ path: 'schoolCalendarSet', query: { id: scope.row.id } }">

                            {{ scope.row.schoolYear }}学年
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column
                    label="第一学期"
                    align="center"
                    width="300px"
                    :resizable="false"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.firstStartDate }}到{{ scope.row.firstEndDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createUser"
                    label="第二学期"
                    align="center"
                    :resizable="false"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.secondStartDate }}到{{ scope.row.secondEndDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    :resizable="false"
                    prop="createUser"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    width="300px"
                    :resizable="false"
                >
                    <template slot-scope="scope">
                        <el-button
                            size="small"
                            type="text"
                            @click="setCurrent(scope.row)"
                            v-if="scope.row.currentSchoolCalendar != 1"
                        >设为当前学年
                        </el-button>
                        <el-button
                            size="small"
                            type="text"
                            @click="jumpToPage('schoolCalendarEdit', { id: scope.row.id })"
                        >编辑
                        </el-button>
                        <el-button
                            size="small"
                            type="text"
                            @click="deleteHandler(scope.row.id)"
                        >删除
                        </el-button>
                        <el-button
                            size="small"
                            type="text"
                            @click="jumpToPage('schoolCalendarSet', { id: scope.row.id })"
                        >设置
                        </el-button>
                        <el-button
                            size="small"
                            type="text"
                            @click="copyHandler(scope.row.id)"
                        >一键设置
                        </el-button>
                        <div v-if="scope.row.currentSchoolCalendar == 1" class="term-hint term-hint--current"></div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import windowResizeMixin from '@/mixins/windowResize';
    import {schoolCalendarList, resetSchoolDate, deleteSchoolCalendar, setCurrentSchoolCalendar} from '@/api/schoolCalendar';

    export default {
        data: function () {
            return {
                dataList: [],
                searchLoading: false,
            }
        },
        mixins: [windowResizeMixin],
        methods: {
            setCurrent(item) {
                setCurrentSchoolCalendar({
                    schoolCalendarId: item.id
                })
                    .then(res => res.data)
                    .then(data => {
                        if (data.result) {
                            this.$message.success('设置成功');
                            this.getList();

                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            },
            jumpToPage(path, query) {
                if (query === undefined || query === null) {
                    query = {}
                }
                this.$router.push({
                    path,
                    query
                })
            },
            deleteHandler(id) {
                this.$confirm('确定要删除选中的校历吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    deleteSchoolCalendar({id})
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message.success('删除成功');
                                this.getList();

                            } else {
                                this.$message.error('error');
                            }
                        })
                        .catch(() => {
                            this.$message.error('error');
                        });
                });
            },
            copyHandler(id) {
                this.$confirm('确定要一键设置选中的校历吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    resetSchoolDate({id})
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message.success('设置成功')
                            } else {
                                this.$message.error('error');
                            }
                        })
                        .catch(() => {
                            this.$message.error('error');
                        });
                });

            },
            getList() {
                schoolCalendarList()
                    .then(res => res.data)
                    .then(data => {
                        if (data.result) {
                            this.dataList = data.data;
                        }
                    })
            }
        },
        created() {
            this.getList();
        }
    }
</script>

<style scoped>
    .top {
        padding-bottom: 10px;
    }
    .term-hint--current {
        background-color: red;
    }

    .term-hint {
        width: 10px;
        height: 10px;
        line-height: 37px;
        display: block;
        float: right;
        border-radius: 20px;
        margin: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/systemData/schoolCalendar/schoolCalendarIndex.vue